import { HOME_IDLE_RELOAD_MS } from '@cibli/shared';

import { PlatformBridge } from './bridge';

/**
 * Performs a web-only app reload by navigating to the root path.
 * Use this as fallback when native reload fails or is not available.
 */
function reloadWeb(): void {
  window.location.assign(new URL('/', window.location.origin).toString());
}

/**
 * Capacitor: trigger a "real" app reload (e.g. restart WebView or activity).
 */
async function reloadCapacitor(): Promise<void> {
  throw new Error('Native app reload not implemented on Capacitor');
}

export const AppManagementBridge = {
  /**
   * Web fallback reload. Always available.
   * Call this in a catch block when reload() fails.
   */
  reloadWeb,

  /**
   * Triggers the best available reload for the current platform.
   */
  async reload(): Promise<void> {
    if (PlatformBridge.isCapacitor) {
      return reloadCapacitor();
    }
    reloadWeb();
  },
};

export { HOME_IDLE_RELOAD_MS };
